(ns practitest.frontend.issues
  (:require
    [ajax.core :as ajax]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.i18n :refer [get-translation] :as i18n]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.forms :as forms]
    [practitest.frontend.forms3.issue :as f3.issue-form]
    [practitest.frontend.issue.common :refer [issue-form-id]]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.similar-items :as similar-items]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(def current-entity :issue)
(def metadata (get metadata/entities-metadata current-entity))

(defn new-controller []
  {:start    (fn [params]
               (re-frame/dispatch [::forms/reset-form-state issue-form-id true current-entity])
               (re-frame/dispatch [::events/set-current-entity-type current-entity])
               (re-frame/dispatch [::events/set-new-entity-traceability current-entity])

               ;; Expand in new mode by default
               (re-frame/dispatch [::similar-items/clear-similar-items])
               (re-frame/dispatch [::similar-items/similar-items-expand current-entity issue-form-id])

               ;; Fail & issue support in new mode
               (when-let [step-id (get-in params [:query :from_step_id])]
                 (if (= step-id "fast_run")
                   ;; Store fast run params for later use
                   (re-frame/dispatch [::store-fast-run-params
                                       (get-in params [:query :ids])
                                       (get-in params [:query :set_id])])
                   ;; Regular step run
                   (re-frame/dispatch [::fetch-fail-and-issue-details step-id])))

               (when-let [annotation-id (get-in params [:query :from_et_id])]
                 (re-frame/dispatch [::issue-from-annotation-data annotation-id]))

               (let [project-id (get-in params [:path :project-id])]
                 (re-frame/dispatch [::f3.entity-form/fetch-fields {:form-id     issue-form-id
                                                                    :entity-type current-entity
                                                                    :project-id  project-id
                                                                    :new?        true}])))

   :identity :parameters})

(defn edit-controller []
  {:start    (fn [params]
               (let [{:keys [issue-id project-id]} (:path params)]
                 ;; TODO: fix this dependency
                 (re-frame/dispatch [::events/set-current-entity-type :issue])
                 (re-frame/dispatch [::subs/set-current-entity-id
                                     :issue
                                     issue-id])
                 (let [fetch-options {:form-id     issue-form-id
                                      :entity-type :issue
                                      :entity-id   issue-id
                                      :project-id  project-id
                                      :new?        false
                                      :got-entity-data [[::similar-items/similar-items-expand :issue :issue-main]]}]
                   (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                   (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                   (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))
                 (re-frame/dispatch [::events/fetch-comments])
                 (re-frame/dispatch [::events/fetch-attachments])
                 (re-frame/dispatch [::events/fetch-history])
                 (re-frame/dispatch [::common-events/trigger-online-request])
                 (re-frame/dispatch [::common-events/reset-expanded :issue (:issue subs/index-grid-keys)])
                 (mixpanel/track "Grid Actions" {"Action" "Edit Issue"})))

   :stop (fn [_params]
           (re-frame/dispatch [::events/clear-current-entity :issue])
           (re-frame/dispatch [::forms/reset-form-state issue-form-id false current-entity])
           (re-frame/dispatch [::similar-items/similar-items-collapse :issue-main])
           (re-frame/dispatch [::common-events/reset-expanded :issue :history2])
           (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
           (re-frame/dispatch [::similar-items/clear-similar-items]))

   :identity :parameters})

(re-frame/reg-event-fx
  ::fetch-fail-and-issue-details
  (fn [{db :db} [_ from-step-id]]
    ;; At least something in fields
    {:db (update db :progress conj ::fetch-fail-and-issue-details)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "issues#create_from_step"
                                        {:p_id (subs/get-current-project-id db)
                                         :id from-step-id})
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-fail-and-issue-details from-step-id]
      :on-failure      [::fail-and-issue-details-error]}}))

(re-frame/reg-event-fx
  ::issue-from-annotation-data
  (fn [{db :db} [_ from-annotation-id]]
    ;; At least something in fields
    {:db (update db :progress conj ::issue-from-annotation-data)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "issues#create_from_et_annotation"
                                        {:p_id (subs/get-current-project-id db)
                                         :id from-annotation-id})
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-issue-from-et-details from-annotation-id]
      :on-failure      [::issue-from-annotation-details-error]}}))

;; Copies field values from entity to form state (to init fail & issue values)
(defn- init-issue
  [db issue from-step-id]
  (forms/set-form-values db issue-form-id issue))

(re-frame/reg-event-fx
  ::got-fail-and-issue-details
  (fn [{db :db} [_ from-step-id response]]
    {:db       (-> db
                   (update :progress disj ::fetch-fail-and-issue-details)
                   (assoc-in [:form-states2 issue-form-id :fail-and-issue :details] response)
                  ;; Copy field values to form (only on new form)
                   (init-issue (:issue response) from-step-id))

    ;; fetch similar issues after populating fields
     :dispatch [::similar-items/fetch-similar-items :issue issue-form-id]}))

(re-frame/reg-event-fx
  ::got-issue-from-et-details
  (fn [{db :db} [_ from-annotation-id response]]
    {:db       (-> db
                   (update :progress disj ::fetch-issue-from-et-details)
                   (assoc-in [:form-states2 issue-form-id :from-et-annotation :details] response)
                     ;; Copy field values to form (only on new form)
                   (init-issue (:issue response) from-annotation-id))

    ;; fetch similar issues after populating fields
     :dispatch [::similar-items/fetch-similar-items :issue issue-form-id]}))

(re-frame/reg-event-db
  ::fail-and-issue-details-error
  (fn [db]
    (-> db
        (update :progress disj ::fetch-fail-and-issue-details))))

(re-frame/reg-event-db
  ::issue-from-annotation-details-error
  (fn [db]
    (update db :progress disj ::fetch-issue-from-et-details)))

(re-frame/reg-event-fx
  ::store-fast-run-params
  (fn [{db :db} [_ fast-run-ids fast-run-set-id]]
    (let [saved-state (.getItem js/sessionStorage "fast_run_state")
          fast-run-data (when saved-state (js->clj (.parse js/JSON saved-state) :keywordize-keys true))
          description (:description fast-run-data)
          name (:name fast-run-data)
          issue-data {:name name
                      :description description}]
      {:db (-> db
               (assoc-in [:form-states2 issue-form-id :fast-run]
                         {:ids fast-run-ids
                          :set-id fast-run-set-id})
               (init-issue issue-data nil))
       :dispatch [::similar-items/fetch-similar-items :issue issue-form-id]})))

(defn main [new? query-params]
  [f3.issue-form/main new? query-params])

(defn ^:export init [options]
  (let [{:keys [translation issue]} (-> options (js->clj :keywordize-keys true))]
    (i18n/append-translation! @(re-frame/subscribe [::subs/current-locale]) translation)))

(comment
  (require '[re-frame.db])
  (tap> re-frame.db/app-db))
